import isNumber from 'lodash/isNumber'
import { Map, List, fromJS } from 'immutable'
import _isUndefined from 'lodash/isUndefined'
import {
  SET_MEDIA_ASSETS_PROCESSING,
  SET_MEDIA_ASSETS_PROCESSING_INFO,
  RESET_MEDIA_ASSETS_MESSAGES,
  SET_MEDIA_ASSETS_MESSAGE,
  RESET_MEDIA_ASSETS_DATA,
  SET_MEDIA_ASSETS_DATA_ASSET,
  SET_MEDIA_ASSETS_DATA_ASSET_PROCESSING,
  SET_MEDIA_ASSETS_BY_CONTENT_ID,
  SET_MEDIA_ASSETS_BY_CONTENT_ID_ERROR,
  SET_MEDIA_ASSET_LIST,
  SET_MEDIA_ASSET_LIST_OFFSET_LIMIT,
  SET_MEDIA_ASSET_ERROR,
  CLEAR_MEDIA_ASSET_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_MEDIA_ASSET_LIST: {
      const {
        storeKey, data, total, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ data, total, processing })),
      )
    }
    case SET_MEDIA_ASSET_LIST_OFFSET_LIMIT: {
      const {
        storeKey, offset, limit, processing,
      } = payload
      return state.update(
        storeKey,
        Map(),
        (branch) => branch.merge(Map({ offset, limit, processing })),
      )
    }
    case SET_MEDIA_ASSET_ERROR: {
      const { err } = payload
      return state.set('error', err)
    }
    case CLEAR_MEDIA_ASSET_ERROR: {
      return state.delete('error')
    }
    case SET_MEDIA_ASSETS_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_MEDIA_ASSETS_PROCESSING_INFO:
      return state.setIn([payload.storeKey, 'processingInfo'], fromJS(payload.info))
    case RESET_MEDIA_ASSETS_MESSAGES:
      return state.deleteIn([payload.storeKey, 'messages'])
    case SET_MEDIA_ASSETS_MESSAGE: {
      const { index, message } = payload
      // If index is provided overwrite the item
      return state.updateIn(
        [payload.storeKey, 'messages'],
        List(),
        (i) => (_isUndefined(index) ? i.push(message) : i.set(index, message)),
      )
    }
    case RESET_MEDIA_ASSETS_DATA:
      return state.withMutations((mutateState) => {
        mutateState.deleteIn([payload.storeKey, 'data'])
        mutateState.deleteIn([payload.storeKey, 'processingInfo'])
        mutateState.deleteIn([payload.storeKey, 'processing'])
        return mutateState
      })
    case SET_MEDIA_ASSETS_DATA_ASSET: {
      const { asset, storeKey, index } = payload
      return state.updateIn([storeKey, 'data'], List(), (data) => (isNumber(index) ? data.set(index, asset) : data.push(asset)))
    }
    case SET_MEDIA_ASSETS_DATA_ASSET_PROCESSING: {
      const { processing, storeKey, index } = payload
      return state.updateIn([storeKey, 'data'], List(), (data) => data.update(index, Map(), (image) => image.set('processing', processing)))
    }
    case SET_MEDIA_ASSETS_BY_CONTENT_ID: {
      const { storeKey, data } = payload
      return state.withMutations((mutateState) => {
        mutateState.setIn([storeKey, 'data'], data)
        mutateState.setIn([storeKey, 'error'], null)
        return mutateState
      })
    }
    case SET_MEDIA_ASSETS_BY_CONTENT_ID_ERROR: {
      const { storeKey, error } = payload
      return state.withMutations((mutateState) => {
        mutateState.setIn([storeKey, 'data'], [])
        mutateState.setIn([storeKey, 'error'], error)
        return mutateState
      })
    }
    default:
      return state
  }
}
